module.exports = __webpack_public_path__ + "img/pattern.55d350a9.png";